import './App.css';
import {BrowserRouter as Router, Routes, Route, Link} from "react-router-dom";
import {useState} from "react";
import Home from "./Pages/Home";
import CreatePost from "./Pages/CreatePost";
import Login from "./Pages/Login";
import {signOut} from 'firebase/auth'
import Submissions from "./Pages/Submissions";
import {auth} from "./firebase-config";

function App() {

  const [isAuth, setIsAuth] = useState(localStorage.getItem("isAuth"));

  const signuserOut = () => {
    signOut(auth).then(() => {
      localStorage.clear();
      setIsAuth(false);
    })
  }

  return (
    <Router className = 'App'>
    <nav className='App-header'>
      <Link to={"/"} className = "item"> HOME </Link>
      
      {!isAuth ? <Link className='item'  to={"/Login"}> LOGIN </Link> : (
        <>
      <Link to ={"/Submissions"} className = "item"> SUBMISSIONS </Link>
      <Link to={"/Createpost"} className = "item"> CREATE POST </Link>
      <button className="item" onClick = {signuserOut}>LOG OUT</button>
      </>
      )}
    </nav>
      <Routes>
        <Route path = "/" element = {<Home isAuth = {isAuth} />} />
        <Route path = "/Createpost" element = {<CreatePost isAuth={isAuth}/>} />
        <Route path = "/Submissions" element = {<Submissions isAuth={isAuth}/>} />
        <Route path = "/Login" element = {<Login setIsAuth={setIsAuth}/>} />
      </Routes>
    </Router>
  );
}

export default App;
